module.exports = __webpack_public_path__ + "static/enterprise-background-8e72cc495861206fe6419336f95f00f7.png";